import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

export const Section = styled.div`
  padding: 3rem  1.5rem;

  ${tablet768`
    padding: 5rem 2.5rem;
  `}

  ${desktop1024`
    padding: 8rem 10.625rem;
  `}
`;

Section.displayName = 'Section';

export const HeadingContainer = styled.div`
  padding-bottom: 6rem;

  ${tablet768`
    width: 25rem;
  `}

  ${desktop1024`
    width: 30rem;
    padding-bottom: 2rem;
  `}
`;

HeadingContainer.displayName = 'HeadingContainer';
